import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { HomeTab } from '../../../types/home/tab';
import { CustomAxiosError } from '../../../types/common/http';
import { HomeTabListEditErrorCode } from '../../../types/home/list';
import { homeApiV2 } from '../../../lib/api/home/homeApiV2';
import { homeTabConverter } from './useHomeTabListQuery';
import { HomeTabsBulkUpdateRequestBodyDto } from '../../../types/api/home-tabs';
import { HOME_TAB_LINK_TYPE_V2 } from '../../../constants/service/app/homeConstantsV2';

const homeTabListRequestConverter = {
  clientToServer: (homeTabList: HomeTab[]) => ({
    homeTabs: homeTabList
      .filter((tab) => tab.linkType !== HOME_TAB_LINK_TYPE_V2.MAIN)
      .map((tab) => ({ id: tab.id, no: tab.no, status: tab.status })),
  }),
};

export const useEditHomeTabListMutate = (
  mutateOption?: UseMutationOptions<HomeTab[], CustomAxiosError<HomeTabListEditErrorCode>, HomeTab[]>,
) =>
  useMutation(async (payload) => {
    const result = await homeApiV2.editHomeTabList(homeTabListRequestConverter.clientToServer(payload));
    return result.homeTabs.map((homeTab) => homeTabConverter.serverToClient(homeTab));
  }, mutateOption);
